export class PregnancyAndBreastfeedingContentModel {
    public pregnancyAndBreastfeedingId: number;
    public langId: number;
    public pregnancyContent: string;
    public breastfeedingContent: string;
}